module.exports = {
    location: "Location",
    dispatching: "Dispatching"
}